<microsec-device-telemetry [telemetryAPICallback]="telemetryAPICallback" [selectedDevice]="selectedDevice" />
